import React from 'react'

import ProjectsListManager from "../../../../core/gd/manager/projects-list-manager"
import NavigationMenuItemProject from "./menu-item-project"
import LocalSettings from "../../local-settings"
import ArrayUtils from "../../../../core/gd/utils/array"
import {NavigationMenuInlineAddParams, NavigationMenuInlineAddType} from "../menu-add-with-popover/popover"
import NavigationMenu_ProjectsInlineAdd from "../../sections/projects/tree/inline-add"
import ProjectSession from "../../../../core/model2/project/project-session"
import {BUS_APP_LAUNCH} from "../../../../core/gd/app-manager/@event"

type Props = {
    localSettings               : any
    expandedProjectsSettingName : string

    projectId                   : ID

    colorized?                  : boolean
}

// const debug = "NavigationMenuItemProjectWithChildren"
const debug = false

export default class NavigationMenuItemProjectWithChildren extends React.Component<Props, any> {

    public localSettings: LocalSettings

    static defaultProps = {
        expandedProjectsSettingName: 'expandedProjects'
    }

    constructor(props: Props) {
        super(props);

        this.localSettings = new LocalSettings()

        this.state = {
            addParentId     : null,
            addPageParentId : null
        }
    }

    componentDidMount() {
        gd.bus.subscribe(BUS_APP_LAUNCH, this, this.onLaunchApp)
    }

    componentWillUnmount() {
        gd.bus.unsubscribe(this)
    }

    onLaunchApp = (data: any) => {
        if (!data.params.projectId) return

        const projectParentsIds = gd.tree.findProjectParents(gd.tree.getProject(data.params.projectId)).map((p:any)=>p.id)
        if (projectParentsIds.includes(this.props.projectId)) {
            this.props.localSettings[this.props.expandedProjectsSettingName] = _.union(this.props.localSettings[this.props.expandedProjectsSettingName].slice(), projectParentsIds)
            this.props.localSettings.save()
        }

        this.forceUpdate()
    }

    onClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        const project = gd.session.projects.get(this.props.projectId)!
        const children = ProjectsListManager.getChildProjects(null, this.props.projectId);

        if (children && project.properties?.handleExpandInsteadOfOpen) {
            this.onMenuItemHandleClick(this.props.projectId, e)
        } else {
            gd.goTo("p/"+this.props.projectId)
            gd.navigation.goToProject(this.props.projectId, '')
        }
    }

    onMenuItemHandleClick = (id: ID, e: React.MouseEvent) => {
        e.stopPropagation()

        const newExpandedItems = this.props.localSettings[this.props.expandedProjectsSettingName].slice()
        const index = newExpandedItems.indexOf(id)
        if (index !== -1) newExpandedItems.splice(index, 1)
        else newExpandedItems.push(id)

        this.props.localSettings[this.props.expandedProjectsSettingName] = newExpandedItems
        this.props.localSettings.save()

        this.forceUpdate()
    }

    onAddInline = (inlineType: NavigationMenuInlineAddType, parentId: ID, params: NavigationMenuInlineAddParams) => {
        debug && console.log(debug, 'onAddInline', inlineType, parentId, params)

        const expandedProjectIds = this.props.localSettings[this.props.expandedProjectsSettingName]
        this.props.localSettings[this.props.expandedProjectsSettingName] = ArrayUtils.addValueToArray(expandedProjectIds, parentId)
        this.props.localSettings.save()

        this.setState({
            inlineType  : inlineType,
            addParentId : parentId,
            params      : params, // for folder, page and embed
        })
    }

    onInlineAdded = (isAdded: boolean) => {
        debug && console.log(debug, 'onInlineAdded', isAdded)

        // if nothing added and project has no children then collapse it
        if (!isAdded && _.isEmpty(ProjectsListManager.getChildProjects(null, this.state.addParentId))) {
            const expandedProjectIds = this.props.localSettings[this.props.expandedProjectsSettingName]
            this.props.localSettings[this.props.expandedProjectsSettingName] = ArrayUtils.removeValueFromArray(expandedProjectIds, this.state.addParentId)
            this.props.localSettings.save()
        }

        this.setState({
            inlineType  : null,
            addParentId : null,
            params      : null
        })
    }

    renderListItems(level: number, parent: ProjectSession | null, submenu: any) {

        let items:ProjectSession[] = []

        if (!parent) {

            const sessionProject = gd.session.projects.get(this.props.projectId)
            if (sessionProject) {
                items.push(sessionProject)
            } else {

                console.error("#9d82389728372dd - no project for pin/starred found at all !")
            }
            //
            // // why do we check based on tree ? not session ... interesting
            // const projToAdd : ProjectTree | null = gd.tree.getProject(this.props.projectId)
            //
            //
            // if (projToAdd) {
            //     items.push(projToAdd)
            // } else {
            //
            //     // console.brown("??? #8723hgdkis can't find project for pin/starred in gd.tree (most likely project is archived)", this.props.projectId)
            //
            //     // this is Archived project
            //     const sessionProject = gd.session.projects.get(this.props.projectId)
            //     if (sessionProject) {
            //         console.log("need fix 2")
            //         // @ts-ignore
            //         items.push(sessionProject)
            //     } else {
            //         console.error("#9d82389728372dd - no project for pin/starred found at all !")
            //     }
            // }

        } else {
            items = parent.treeChildren
        }

        if (items && items.length > 0) {
            _.map(items, (listItem)=>{
                const isExpanded = this.props.localSettings[this.props.expandedProjectsSettingName]?.includes(listItem.id)
                const showChildProjects = isExpanded && !_.isEmpty(listItem.treeChildren)
                const showInlineAdd = this.state.addParentId === listItem.id
                const fragment = gd.router.history.fragment || ''
                const isSelected = _.startsWith(fragment, 'p/') && fragment.includes(listItem.id)

                const sessionProject = gd.session.projects.get(listItem.id)

                // this hides archived pins
                if (!sessionProject || sessionProject.isArchived) {
                    return
                }

                submenu.push(<NavigationMenuItemProject key                     = {listItem.id}
                                                        colorized               = {this.props.colorized}
                                                        project                 = {listItem}
                                                        isSelected              = {isSelected}
                                                        isExpanded              = {isExpanded}
                                                        level                   = {level}
                                                        onMenuItemHandleClick   = {this.onMenuItemHandleClick}
                                                        onAddInline             = {this.onAddInline}
                                                        {...this.props}/>)


                if (showChildProjects) {
                    this.renderListItems(level+1,listItem,submenu);
                }

                if (showInlineAdd) {
                    submenu.push(<NavigationMenu_ProjectsInlineAdd key      = {'add_{0}'.f(listItem.id)}
                                                                   type     = {this.state.inlineType}
                                                                   level    = {level+1}
                                                                   parentId = {this.state.addParentId}
                                                                   params   = {this.state.params}
                                                                   callback = {this.onInlineAdded}/>)
                }
            })
        }
    }

    render() {

        const submenu: any[] = []
        this.renderListItems(0, null, submenu)

        return (
            <div className="root-pinned-project-container with-children">
                {submenu}
            </div>
        )
    }
}